export const NOTIFICATION_MESSAGES = {
  // --- Общие ---
  SUCCESS: "Успешно",
  ERROR: "Ошибка",
  SUCCESS_ALT: "Успех",

  // --- Записи журнала ---
  ENTRY_SIGNED_SUCCESS: "Запись подписана",
  ENTRY_SIGNED_SUCCESS_ALT: "Запись успешно подписана",
  ENTRY_RECALLED_SUCCESS_ALT: "Запись успешно отозвана",
  ENTRY_SIGN_ERROR: "Ошибка при подписании записи",
  ENTRY_REJECTED_SUCCESS: "Запись отклонена",
  ENTRY_REJECT_ERROR: "Ошибка при отклонении",
  ENTRY_RECALLED_SUCCESS: "Запись отозвана",
  ENTRY_RECALLED_FROM_SIGNING_SUCCESS: "Запись отозвана с подписания",
  ENTRY_RECALL_ERROR: "Ошибка при отзыве",
  ENTRY_RECALL_ERROR_ALT: "Ошибка при отзыве записи",
  ENTRY_RETURNED_TO_NEW: "Запись возвращена в статус NEW",
  ENTRY_RETURNED_TO_NEW_ALT: "Запись возвращена в статус 'Новый'",
  ENTRY_RETURNED_TO_WORK: "Запись возвращена в работу",
  ENTRY_RETURN_ERROR: "Ошибка при возврате записи",
  ENTRY_RETURN_TO_WORK_ERROR: "Не удалось вернуть запись в работу",
  ENTRY_SENT_TO_SIGNING: "Отправлено на подписание",
  ENTRY_SENT_TO_SIGNING_ALT: "Запись отправлена на подписание",
  ENTRY_SEND_TO_SIGNING_ERROR: "Ошибка при отправке на подписание",
  ENTRY_SEND_TO_SIGNING_ERROR_ALT: "Не удалось отправить на подписание",
  ENTRY_BULK_SENT_SUCCESS: "Групповая отправка выполнена",
  ENTRY_BULK_SEND_ERROR: "Ошибка при групповой отправке",
  ENTRY_DELETED_SUCCESS: "Запись удалена",
  ENTRY_DELETE_ERROR: "Ошибка при удалении записи",
  ENTRY_DELETE_ERROR_ALT: "Ошибка при удалении",
  ENTRY_DELETE_NOT_POSSIBLE: "Не удалось удалить запись",
  ENTRY_REJECT_NOT_POSSIBLE: "Не удалось отклонить запись",
  ENTRY_DELETE_RELATED_DATA_ERROR: "Есть связанные данные, удаление невозможно выполнить",
  ENTRY_CREATED_DESC: "Запись создана",
  ENTRY_CREATE_ERROR: "Ошибка при создании записи",
  ENTRY_CREATE_FAILED_DESC: "Не удалось создать запись",
  ENTRY_ADDED_SUCCESS: "Запись успешно добавлена",
  ENTRY_ADD_ERROR: "Ошибка при добавлении записи",
  ENTRY_UPDATED_SUCCESS: "Запись успешно обновлена",
  ENTRY_UPDATE_ERROR: "Ошибка при обновлении записи",
  ENTRY_UPDATED_WITH_SIGN_SUCCESS: "Запись успешно обновлена с подписью",
  ENTRY_UPDATE_WITH_SIGN_ERROR: "Ошибка при обновлении записи с подписью",
  ENTRY_STATUS_UPDATED_SUCCESS: "Статус обновлён на 'Новый'",
  ENTRY_STATUS_UPDATE_ERROR: "Не удалось обновить статус",
  ENTRY_UPDATED_DESC: "Запись обновлена",
  ENTRY_UPDATE_FAILED_DESC: "Не удалось обновить запись",
  ENTRY_SIGNED_UPDATED_DESC: "Подписанная запись обновлена",
  ENTRY_SIGNED_UPDATE_FAILED_DESC: "Не удалось обновить подписанную запись",
  ENTRY_SIGNED_P2_UPDATED_DESC: "Подписанная запись (часть 2) обновлена",
  ENTRY_SIGNED_P2_UPDATE_FAILED_DESC: "Не удалось обновить подписанную запись (часть 2)",

  // --- Мультиотправка ---
  ENTRY_PARTIAL_SENT_TO_SIGNING: "Частично отправлено на подписание",
  ENTRY_BULK_SENT_TO_SIGNING: "Успешно отправлено на подписание",
  ENTRY_BULK_SEND_TO_SIGNING_ERROR: "Ошибка при массовой отправке на подписание",

  // --- Дубль организации ---
  SAVE_DUPLICATE_ORG_ERROR: "Ошибка сохранения",
  SAVE_DUPLICATE_ORG_ERROR_DESC: "Нельзя добавить две одинаковые организации в запись",
  SAVE_VERSION_NOT_FOUND_ERROR_DESC: "Не удалось определить версию подписанной записи. Обновите страницу и попробуйте снова.",

  // --- XML подписание ---
  XML_SIGN_GENERATION_ERROR: "Ошибка при генерации XML подписи",
  XML_SIGN_P1_GENERATION_ERROR: "Ошибка генерации XML подписи (часть 1)",
  XML_SIGN_P2_GENERATION_ERROR: "Ошибка генерации XML подписи (часть 2)",
  XML_SIGN_SEND_ERROR: "Ошибка отправки подписи",
  XML_SIGN_P1_SEND_ERROR: "Ошибка отправки подписи (часть 1)",
  XML_SIGN_P2_SEND_ERROR: "Ошибка отправки подписи (часть 2)",
  XML_SIGN_PROCESSING_ERROR: "Ошибка при обработке подписи",
  XML_SIGN_EXTRACT_FAILED_DESC: "Не удалось извлечь данные подписи из XML",
  XML_RETRY_PREPARATION_SUCCESS_DESC: "Запущена повторная подготовка XML",
  XML_RETRY_PREPARATION_FAILED_DESC: "Не удалось повторно отправить на подготовку XML",
  SIGN_ERROR: "Произошла ошибка",
  SIGN_SEND_ERROR: "Произошла ошибка при отправлении подписи",

  // --- Титульный лист ---
  TITLE_COMMENT_REQUIRED: "Требуется комментарий",
  TITLE_REJECT_COMMENT_REQUIRED_DESC: "Пожалуйста, укажите причину отклонения титульного листа.",
  TITLE_REVOKE_COMMENT_REQUIRED_DESC: "Пожалуйста, укажите причину отзыва титульного листа.",
  TITLE_REJECTED_DESC: "Титульный лист отклонен",
  TITLE_REJECT_FAILED_DESC: "Не удалось отклонить титульный лист",
  TITLE_REVIEWED_DESC: "Титульный лист проверен",
  TITLE_REVIEW_FAILED_DESC: "Титульный лист не проверен",
  TITLE_SENT_TO_GSN_DESC: "Титульный лист отправлен в ГСН",
  TITLE_SEND_TO_GSN_FAILED_DESC: "Не удалось отправить титульный лист в ГСН",
  TITLE_SENT_TO_GSN_REVIEW_DESC: "Титульный лист отправлен на проверку в ГСН",
  TITLE_FILL_MISSING: "Заполните недостающие данные",
  TITLE_FILL_MISSING_DESC: "Пожалуйста, заполните следующие поля:",
  TITLE_SAVED_DESC: "Титульный лист сохранен",
  TITLE_SAVE_VALIDATION_ERROR_DESC: "Сохранение невозможно, проверьте заполненность полей: номер журнала, краткие проектные характеристики объекта, начало строительства, начало ведения журнала, либо уникальность указанного номера журнала",
  TITLE_SENT_TO_REVIEW_DESC: "Титульный лист отправлен на проверку",
  TITLE_RESENT_DESC: "Титульный лист повторно отправлен",
  TITLE_SEND_TO_REVIEW_FAILED_DESC: "Не удалось отправить на проверку",
  TITLE_SEND_TO_REVIEW_FAILED_DESC_ALT: "Не удалось отправить титульный лист на проверку",
  TITLE_RETURNED_TO_WORK_DESC: "Титульный лист возвращен в работу",
  TITLE_REVOKED_DESC: "Титульный лист отозван",
  TITLE_REVOKED_RETURN_WARNING_DESC: "Не удалось автоматически вернуть документ в работу. Нажмите «Вернуть в работу».",
  TITLE_REVOKE_FAILED_DESC: "Не удалось отозвать титульный лист",
  TITLE_GSN_REJECTED_DESC: "Титульный лист отклонён для ГСН",
  DATA_SAVED_DESC: "Данные сохранены",
  SECTION_UNAVAILABLE: "Раздел пока недоступен",

  // --- Участники ---
  PARTICIPANT_DELETED_DESC: "Участник успешно удален",
  PARTICIPANT_DELETE_FAILED_DESC: "Не удалось удалить участника",

  // --- Настройки / сотрудники ---
  EMPLOYEE_ADDED_DESC: "Сотрудник добавлен",
  EMPLOYEE_ADD_ERROR: "Ошибка при добавлении сотрудника",
  EMPLOYEE_RIGHT_PAUSED_DESC: "Приостановлено право",
  EMPLOYEE_RIGHT_PAUSE_ERROR: "Ошибка при приостановлении права",

  // --- Документы ---
  DOCUMENT_ADD_FAILED_DESC: "Не удалось добавить документ",
  DOCUMENT_AND_REPRESENTATIVE_ADDED_DESC: "Документ и представитель успешно добавлены",

  // --- Скачивание файлов ---
  DOWNLOAD_ERROR: "Ошибка при загрузке",
  DOWNLOAD_NO_LINK_DESC: "Ссылка для скачивания не найдена",
  DOWNLOAD_FILE_ERROR_DESC: "Ошибка при скачивании файла",
  DOWNLOAD_FILE_FAILED_DESC: "Не удалось скачать файл",
  DOWNLOAD_INIT_FAILED_DESC: "Не удалось инициировать скачивание файла",
  DOCUMENT_LOADED: "Документ загружен",
  DOCUMENT_NO_LINK_DESC: "Ссылка на документ не найдена",
  DOCUMENT_LOAD_FAILED_DESC: "Не удалось загрузить документ",

  // --- Проекты ---
  PROJECT_CREATED_DESC: "Создали новый проект",
  PROJECT_CREATE_FAILED: "Не удалось создать проект",
  PROJECT_SETTINGS_DISPLAY_ERROR: "Не можем отобразить настройки проекта",

  // --- Организации ---
  ORG_NOT_FOUND_ERROR: "Не удалось добавить организацию, организации нет в системе.",
  ORG_NOT_FOUND_ERROR_DESC: "Предварительно добавьте организацию в систему или обратитесь к Администратору системы",

  // --- Представители ---
  REPRESENTATIVE_NOT_SELECTED: "Не выбран представитель",
  REPRESENTATIVE_NOT_SELECTED_DESC: 'Введите корректные данные и нажмите кнопку "найти"',
  REPRESENTATIVE_ADDED_DESC: "Представитель успешно добавлен",
  REPRESENTATIVE_ADD_FAILED_DESC: "Не удалось добавить представителя",
  REPRESENTATIVE_CONSTRUCTION_ADD_FAILED_DESC: "Не удалось добавить представителя строительного контроля",
  USER_NOT_FOUND: "Неудачный запрос",
  USER_NOT_FOUND_DESC: "Пользователь не найден",

  // --- Администраторы проекта ---
  ADMIN_ADDED_DESC: "Удалось добавить админа",
  ADMIN_ADD_FAILED_DESC: "Не удалось добавить админа",
  ADMIN_REMOVED_DESC: "Удалось удалить админа",
  ADMIN_REMOVE_FAILED_DESC: "Не удалось удалить админа",
  ID_COPIED_DESC: "Id скопирован в буфер обмена",

  // --- Администраторы журнала ---
  JOURNAL_ADMIN_ADDED_DESC: "Администратор добавлен",
  JOURNAL_ADMIN_ADD_ERROR: "Ошибка при добавлении администратора",
  JOURNAL_ADMIN_DELETED_DESC: "Администратор удален",
  JOURNAL_ADMIN_DELETE_ERROR: "Ошибка при удалении администратора",

  // --- Журналы объекта ---
  JOURNAL_CREATED_DESC: "Создали журнал",
  JOURNAL_CREATE_FAILED_DESC: "Невозможно создать журнал",
  JOURNAL_DELETED_DESC: "Удалили журнал",
  JOURNAL_DELETE_FAILED_DESC: "Невозможно удалить",

  // --- Настройки объекта ---
  OBJECT_SETTINGS_DISPLAY_ERROR: "Не можем отобразить настройки обьекта",

  // --- Реестр актов ---
  REGISTRY_DATA_UNAVAILABLE: "Данные реестра недоступны",
  REGISTRY_SERVER_ERROR_DESC: "Не удалось загрузить данные с сервера. Отображаются тестовые данные.",
  REGISTRY_EMPTY_LIST_DESC: "Сервер вернул пустой список. Отображаются тестовые данные.",

  // --- Доступ к версиям ---
  VERSIONS_ACCESS_DENIED: "Нет доступа",
  VERSIONS_ACCESS_DENIED_DESC: "У вас нет прав на просмотр списка версий",

  // --- Интеграция ---
  INTEGRATION_CONNECTED: "Интеграция подключена",
  INTEGRATION_CONNECTED_DESC: "Настройки интеграции успешно сохранены",
  INTEGRATION_CONNECT_FAILED: "Ошибка при подключении",
  INTEGRATION_CONNECT_FAILED_DESC: "Не удалось подключить интеграцию. Попробуйте еще раз.",
  INTEGRATION_SETTINGS_SAVED: "Настройки сохранены",
  INTEGRATION_SETTINGS_SAVED_DESC: "Интеграционные настройки успешно сохранены",
  INTEGRATION_SETTINGS_SAVE_FAILED: "Ошибка при сохранении",
  INTEGRATION_SETTINGS_SAVE_FAILED_DESC: "Не удалось сохранить настройки интеграции. Попробуйте еще раз.",
  INTEGRATION_DISCONNECTED: "Интеграция отключена",
  INTEGRATION_DISCONNECTED_DESC: "Интеграция успешно отключена",
  INTEGRATION_DISCONNECT_FAILED: "Ошибка при отключении",
  INTEGRATION_DISCONNECT_FAILED_DESC: "Не удалось отключить интеграцию. Попробуйте еще раз.",
  INTEGRATION_ID_COPIED: "ID скопирован",
  INTEGRATION_ID_COPIED_DESC: "Идентификатор скопирован в буфер обмена",
  INTEGRATION_ID_COPY_FAILED: "Ошибка копирования",
  INTEGRATION_ID_COPY_FAILED_DESC: "Не удалось скопировать ID в буфер обмена",
} as const;
